import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { enableProdMode } from '@angular/core';

// OpenTelemetry imports
import { WebTracerProvider } from '@opentelemetry/sdk-trace-web';
import { registerInstrumentations } from '@opentelemetry/instrumentation';
import { XMLHttpRequestInstrumentation } from '@opentelemetry/instrumentation-xml-http-request';
import { FetchInstrumentation } from '@opentelemetry/instrumentation-fetch';
if (process.env['NODE_ENV'] === 'production') {
 enableProdMode();
}


// ---- Opentelemetry Setup ----
// const provider = new WebTracerProvider();
// registerInstrumentations({
//     instrumentations: [
//         new XMLHttpRequestInstrumentation({
//             propagateTraceHeaderCorsUrls: /.*/,
//         }),
//         new FetchInstrumentation({
//             propagateTraceHeaderCorsUrls: /.*/,
//         }),
//     ]
// });
  

// ---- End of OpenTelemetry Setup ----

platformBrowserDynamic()
 .bootstrapModule(AppModule)
 .catch((err) => console.error(err));
